import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Benefits from './components/Benefits';
import CTA from './components/CTA';
import Footer from './components/Footer';

function App() {
  const [language, setLanguage] = useState('en'); // 'en' English, 'de' Swiss German

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'de' : 'en');
  };

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 font-body">
      <Header language={language} onToggleLanguage={toggleLanguage} />
      <Hero language={language} />
      <Features language={language} />
      <HowItWorks language={language} />
      <Benefits language={language} />
      <CTA language={language} />
      <Footer language={language} />
    </div>
  );
}

export default App;
